import { DefaultTheme } from '../../components/theme';
import { CSS as CollectionListCSS } from '../collection.list/collection.list.style';

export const CSS = {
	container: 'c-PMCollectionList',
	toolbar: {
		container: 'c-PMCollectionList__Toolbar',
	},
	collections: {
		container: 'c-PMCollectionList__Collections',
		content: 'c-PMCollectionList__Content',
		isEmpty: 'c-PMCollectionList__Collections--empty',
	},
	map: {
		container: 'c-PMCollectionList__Map',
		inner: 'c-PMCollectionList__MapInner',
		button: 'c-PMCollectionList__MapBtn',
	},
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'flex-direction': 'column',
		height: '100%',
		'background-color': DefaultTheme.background.grey,
	},
	[CSS.toolbar.container]: {
		position: 'relative',
	},
	[CSS.collections.container]: {
		flex: 1,
		'min-height': '100px',
		display: 'flex',
		'flex-direction': 'column',
	},
	[CSS.collections.content]: {
		display: 'flex',
		flex: 1,
		'flex-direction': 'row',
		overflow: 'hidden',
		[`& .${CollectionListCSS.container}`]: {
			flex: 1,
			overflow: 'auto',
		},
	},
	[CSS.collections.isEmpty]: {
		'flex-direction': 'row',
		'justify-content': 'center',
		'align-items': 'center',
	},
	[CSS.map.container]: {
		flex: 0.77,
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		// Positioned so the line-draw popup anchors over the inset map.
		position: 'relative',
	},
	// Wraps the map fragment alone (see the render site for why).
	[CSS.map.inner]: {
		width: '100%',
		height: '100%',
	},
	[CSS.map.button]: {
		position: 'absolute',
		bottom: DefaultTheme.space(8),
		left: DefaultTheme.space(3),
		color: DefaultTheme.font.color.primary,
		'background-color': DefaultTheme.background.offWhite,
		'box-shadow': DefaultTheme.shadow.box.dp6,
	},
};
